/* Quantity and validation enhancement only. Theme scripts own variants, media, cart and wallets. */
(() => {
  'use strict';
  if (window.MuteMeProducts) { window.MuteMeProducts.init(document); return; }
  const instances = new Map();

  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-mm-product-hero]')];
    if (scope.matches?.('[data-mm-product-hero]')) roots.unshift(scope);
    roots.forEach(root => {
      if (instances.has(root)) return;
      const form = root.querySelector('[data-product-form]');
      if (!form) return;
      const controller = new AbortController();
      const { signal } = controller;
      const quantity = form.querySelector('[name="quantity"]');
      const minus = form.querySelector('[data-mm-quantity-step="-1"]');
      const plus = form.querySelector('[data-mm-quantity-step="1"]');
      const updateQuantity = () => {
        if (!quantity) return;
        const value = quantity.valueAsNumber;
        if (minus) minus.disabled = !Number.isFinite(value) || value <= Number(quantity.min || 1);
        if (plus) plus.disabled = Boolean(quantity.max) && value >= Number(quantity.max);
      };
      form.addEventListener('click', event => {
        const button = event.target.closest('[data-mm-quantity-step]');
        if (!button || !quantity) return;
        if (!Number.isFinite(quantity.valueAsNumber)) quantity.value = quantity.min || '1';
        else if (Number(button.dataset.mmQuantityStep) > 0) quantity.stepUp();
        else quantity.stepDown();
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal });
      quantity?.addEventListener('input', updateQuantity, { signal });
      quantity?.addEventListener('change', updateQuantity, { signal });
      // Legacy AJAX intercepts the submit input click before native constraint validation.
      form.addEventListener('click', event => {
        if (event.target.closest('.add-to-cart input[type="submit"]') && !form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.reportValidity();
        }
      }, { capture: true, signal });
      updateQuantity();
      root.classList.add('mm-product-ready');
      instances.set(root, () => { controller.abort(); root.classList.remove('mm-product-ready'); });
    });
  }
  const ready = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of instances) {
      if (event.target.contains(root)) { destroy(); instances.delete(root); }
    }
  });
  window.MuteMeProducts = { init };
})();
